import { useHistory } from 'react-router-dom'
import { useMutation } from 'react-query'
import http from 'utils/http'
import { endpoints } from 'global/endpoints'
import { toast } from 'react-toastify'
import { routePaths } from 'global/routePaths'

const createCategory = (postData) => {
  const updatedEndpoints = endpoints.category.base
  return http('multipart').post(updatedEndpoints, postData)
}

export function useCreateCategory() {
  const history = useHistory()

  return useMutation(createCategory, {
    onSuccess: () => {
      toast.success('Category has been added successfully!')
      history.push(routePaths.home.category.base)
    },
    onError: (error) => {
      const message = error.response.data.message
      toast.error(message)
    },
  })
}
